export default "__VITE_ASSET__Dm5ymRke__"